import { MinotaureInvestisseurFilterInput } from '@lib/models/generated/graphql';
import { ItemFiltreCustomBuilder, LineOperator } from '../filtre-builder.model';

const NON_INVITE = 'MAGIC_LINK';

/**
 * Un investisseur sans ligne dans MyStellium est considéré "Non invité" (MAGIC_LINK).
 * HotChocolate ne permettant pas de filtrer directement sur la nullité d'un champ objet/navigation
 * (myStelliumInvestisseur: null), on passe par le booléen dédié hasMyStelliumInvestisseur.
 */
export class MyStelliumStatusFiltreBuilder extends ItemFiltreCustomBuilder {
  override buildFilter(_operator: LineOperator, value: unknown): MinotaureInvestisseurFilterInput {
    const statuses = (Array.isArray(value) ? value.flat() : [value]) as string[];
    const includesNonInvite = statuses.includes(NON_INVITE);
    const withStatus = {
      and: [{ hasMyStelliumInvestisseur: { eq: true } }, { myStelliumInvestisseur: { accountStatus: { in: statuses } } }],
    };
    const noLine = { hasMyStelliumInvestisseur: { eq: false } };

    const filter = includesNonInvite ? { or: [noLine, withStatus] } : withStatus;
    return filter as MinotaureInvestisseurFilterInput;
  }
}
